<template>
  <div :class="['main-view component-wrapper height-100', { 'is-mobile': isMobile }]">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { isMobile } from '@/core/helpers/ui.helper';
</script>

<style lang="scss" scoped>
.main-view {
  width: 100%;
}
</style>
